import 'rxjs-compat/add/operator/catch';
import 'rxjs-compat/add/operator/filter';
import 'rxjs-compat/add/operator/map';
import 'rxjs-compat/add/operator/mergeMap';
import 'rxjs-compat/add/operator/switchMap';
import 'rxjs-compat/add/operator/do';
import 'rxjs-compat/add/operator/finally';
import 'rxjs-compat/add/observable/throw';
